import {
    FETCH_DISCLAIMER_ACTIVE_BEGIN,
    FETCH_DISCLAIMER_ACTIVE_SUCCESS,
    FETCH_DISCLAIMER_ACTIVE_FAILURE
} from 'app/actions/DisclaimerActions';

const initialState = {

    disclaimer: {},
    isLoading: false

};

export default function DisclaimerReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_DISCLAIMER_ACTIVE_BEGIN:
            return {
                ...state,
                isLoading: true
            }

        case FETCH_DISCLAIMER_ACTIVE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                disclaimer: action.payload
            }
        case FETCH_DISCLAIMER_ACTIVE_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        default:
            return state;
    }
};

export const getDisclaimerActive = state => {
    return state.disclaimer;
}

export const getIsLoadingDisclaimerActive = state => {
    return state.isLoading;
}
